// src/telemed/TelemedJoin.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { getApiBase } from '../utils/runtime';

const API_BASE = getApiBase();

export default function TelemedJoin() {
  const { sessionId } = useParams();
  const [search] = useSearchParams();
  const navigate = useNavigate();
  const { isEnglish } = useLanguage();

  const roleParam = (search.get('role') || '').toLowerCase();

  const [error, setError] = useState('');
  const [status, setStatus] = useState(isEnglish ? 'Preparing your telehealth session...' : 'Initialisation...');

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setStatus(isEnglish ? 'Fetching your secure join link...' : 'Recuperation du lien de connexion...');

        // Validation simple
        if (!['patient', 'professional'].includes(roleParam)) {
          throw new Error(isEnglish ? 'Invalid "role" parameter (patient|professional)' : 'Parametre "role" invalide (patient|professional)');
        }

        // Appel backend pour récupérer le joinUrl avec token
        const resp = await fetch(
          `${API_BASE}/telemedicine-sessions/${sessionId}/join-link?role=${encodeURIComponent(roleParam)}`
        );
        if (!resp.ok) {
          const txt = await resp.text().catch(() => '');
          throw new Error(`join-link HTTP ${resp.status}${txt ? `: ${txt}` : ''}`);
        }
        const { joinUrl } = await resp.json();
        if (!joinUrl) {
          throw new Error(isEnglish ? 'The join link is missing.' : 'joinUrl manquant');
        }

        // Redirige vers l’URL finale: /telemed/:sessionId?role=...&token=...
        // (joinUrl vient déjà complet du backend — on peut y aller directement)
        if (mounted) {
          // 1) Redirection "hard" vers l’URL complet renvoyé:
          window.location.href = joinUrl;

          // OU 2) Si tu veux rester "SPA" et garder le même domaine :
          // const u = new URL(joinUrl);
          // navigate(`/telemed/${sessionId}?${u.searchParams.toString()}`, { replace: true });
        }
      } catch (e) {
        console.error('TelemedJoin error:', e);
        if (mounted) {
          setError(e.message || (isEnglish ? 'Something went wrong.' : 'Erreur'));
          setStatus(isEnglish ? 'Unable to continue' : 'Echec');
        }
      }
    })();
    return () => { mounted = false; };
  }, [sessionId, roleParam, navigate, isEnglish]);

  return (
    <div style={{ padding: 20 }}>
      <h2>{isEnglish ? 'Joining your telehealth visit' : 'Connexion a la teleconsultation'}</h2>
      <p>{status}</p>
      {error ? <p style={{ color: 'crimson' }}>{error}</p> : null}
      <p style={{ fontSize: 13, color: '#666' }}>
        {isEnglish ? 'If you are not redirected automatically, please check your link or contact support.' : 'Si vous n etes pas redirige automatiquement, verifiez votre lien ou contactez le support.'}
      </p>
    </div>
  );
}
